<template>
    <div style="margin:0 10px">
        <router-view></router-view>
        <div class="card">
            <!-- search -->
            <div class="search d-flex a-center j-sb">
                <div class="d-flex a-center">
                    <div style="width:200px;margin-right:10px;">
                        <el-input type="text" v-model="keyword" placeholder="请输入分类编码或名称" class="search-input" clearable @keyup.enter.native="init"></el-input>
                    </div>
                    <el-button class="search-button" @click="init"></el-button>
                    <el-button class="add-button" @click="$router.push({name:'agents_category_add'})"></el-button>
                </div>
            </div>

            <!-- handle -->
            <div class="handle"></div>

            <!-- table -->
            <div class="table" style="margin-top:20px;">
                <el-table
                    :data="filteredData"
                    style="width: 100%;"
                    v-loading="loading"
                >
                    <el-table-column prop="id" label="ID" align="center" width="80"></el-table-column>
                    <el-table-column prop="categoryCode" label="分类编码" align="center"></el-table-column>
                    <el-table-column prop="categoryName" label="分类名称" align="center"></el-table-column>
                    <el-table-column prop="description" label="描述" align="center" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="" label="操作" align="center" width="180">
                        <template slot-scope="scope">
                            <el-button @click="$router.push({name:'agents_category_add',query:{id:scope.row.id}})" type="text" size="small" class="edit-action">编辑</el-button>
                            <el-popconfirm
                                    title="是否确定删除？"
                                    confirm-button-text="确认删除"
                                    @confirm="handleDel(scope.row)"
                                >
                                    <el-button style="margin-left: 10px;" slot="reference" type="text" class="delete-action">删除</el-button>
                                </el-popconfirm>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

        </div>
    </div>
</template>

<script>
import { category, categoryDel } from '../../../request/api/agents';
export default {
    data(){
        return {
            tableData: [],
            keyword: '',
            loading:false,
        }
    },
    computed:{
        //分类为全量列表，按编码或名称做前端过滤
        filteredData(){
            const kw = (this.keyword || '').trim().toLowerCase()
            if(!kw) return this.tableData
            return this.tableData.filter(item=>{
                const code = (item.categoryCode || '').toLowerCase()
                const name = (item.categoryName || '').toLowerCase()
                return code.includes(kw) || name.includes(kw)
            })
        }
    },
    watch:{
        $route(val ,old){
            //返回刷新
            if(val.name=='agents_category') {
                this.init()
            }
        }
    },
    created(){
        this.init()
    },

    methods:{
        init(){
            this.loading=true
            category().then(res=>{
                this.tableData = res.data || []
                this.loading=false
            }).catch(()=>{
                this.loading=false
            })
        },
        handleDel(row){
            categoryDel({id:row.id}).then(res=>{
                if(res.code!=0) return this.$notify({title: '失败',message:res.msg,type: 'error'});
                this.init()
                this.$notify({title: '成功',message: "SUCCESS",type: 'success'});
            })
        },
    }
}
</script>


<style scoped lang="less">


</style>
